// generated by srcset-codegen
import src from "./mark-neon.svg";

const width = 740;
const height = 418;
export default { src, width, height };
